<template>
  <td class="align-middle cursorPointer">
    <div @click="$router.push({ name: 'Home', query: { user_id: fbUid } })" class="ellipsis userId" :title="fbUid">
      {{ fbUid }}
    </div>
  </td>
</template>

<script>
export default {
  props: {
    fbUid: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.userId {
  width: 70px;
}
</style>
